"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    wrapper: {
        position: "absolute",
        bottom: 50,
    },
    root: {
        position: "relative",
        overflow: "auto",
        "@media only screen and (max-width: 1000px)": {
            maxHeight: 112,
        },
    },
    option: {
        width: 120,
        background: "#ffffff",
        fontSize: 12,
        color: "#374151",
        fontFamily: "sans-serif",
        padding: 5,
        paddingLeft: 10,
        paddingRight: 10,
        display: "flex",
        cursor: "pointer",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
            background: "#f3f4f6",
        },
    },
    activeOption: {
        background: "#d1d5db",
        fontSize: 12,
        color: "#374151",
        fontFamily: "sans-serif",
        padding: 5,
        paddingLeft: 10,
        paddingRight: 10,
        display: "flex",
        cursor: "pointer",
    },
    disabledOption: {
        cursor: "not-allowed",
        background: "#313131",
        fontSize: 12,
        color: "#a0a0a0",
        fontFamily: "sans-serif",
        padding: 5,
        paddingLeft: 10,
        paddingRight: 10,
        display: "flex",
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map